"use strict";

var _slicedToArray = require("/opt/render/project/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

const tslib_1 = require("tslib");

const hsluv_1 = require("hsluv");

const base_1 = require("./configs/base");

function colorFactory(theme, scheme, config = base_1.config) {
  return Object.assign({}, ...Object.entries(theme).map(([role, hex]) => {
    if (typeof hex !== 'string') {
      return null;
    }

    const base = hsluv_1.hexToHsluv(hex);
    const variants = config[role] || [];
    return Object.assign({}, variants.reduce((accumulator, _a) => {
      var name = _a.name,
          settings = tslib_1.__rest(_a, ["name"]);

      const _settings$scheme = settings[scheme],
            _settings$scheme$hue = _settings$scheme.hue,
            hue = _settings$scheme$hue === void 0 ? base[0] : _settings$scheme$hue,
            _settings$scheme$satu = _settings$scheme.saturation,
            saturation = _settings$scheme$satu === void 0 ? base[1] : _settings$scheme$satu,
            _settings$scheme$ligh = _settings$scheme.lightness,
            lightness = _settings$scheme$ligh === void 0 ? base[2] : _settings$scheme$ligh,
            _settings$scheme$alph = _settings$scheme.alpha,
            alpha = _settings$scheme$alph === void 0 ? 1 : _settings$scheme$alph;

      const resolve = (value, baseToResolve) => {
        return typeof value === 'number' ? value : value(baseToResolve);
      };

      const _hsluv_1$hsluvToRgb$m = hsluv_1.hsluvToRgb([resolve(hue, base[0]), resolve(saturation, base[1]), resolve(lightness, base[2])]).map(channel => Math.round(channel * 255)),
            _hsluv_1$hsluvToRgb$m2 = _slicedToArray(_hsluv_1$hsluvToRgb$m, 3),
            red = _hsluv_1$hsluvToRgb$m2[0],
            green = _hsluv_1$hsluvToRgb$m2[1],
            blue = _hsluv_1$hsluvToRgb$m2[2];

      return Object.assign(Object.assign({}, accumulator), {
        [name]: "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")")
      });
    }, {}));
  }));
}

exports.colorFactory = colorFactory;